import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Line from '../../../packages/kiti/components/helpers/Line'
import SearchInput from '../SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Switch from '../Switch'
import Text from '../../../packages/kiti/components/presentation/Text'

const ModalPickerHeader = ({
  filtersList,
  title,
  useDisabledOption,
  useDeletedOption,
  disableOptions,
  disableControl
}) => {
  const { t } = useTranslation('common')
  const [active, setActive] = React.useState('search')

  const includeDisabled = useFilterValue('includeDisabled', false)
  const includeDeleted = useFilterValue('includeDeleted', false)
  const handleChange = useChangeFilterValue()

  const hasFilters = !!filtersList
  const hasOptions = (useDisabledOption || useDeletedOption) && !disableOptions

  return (
    <>
      <Separator padding={0.5} bgColor="dark1">
        <Text align="center" color="white">
          {title}
        </Text>
      </Separator>

      {!disableControl && (
        <Grid align="center" gap={0.5} padding={1} wrap>
          <Col flex={1} minHeight="2.75rem" justify="center">
            {!active && <Text bold>{t('selectOneOrMore')}</Text>}
            {active === 'search' && <SearchInput noMargin autoFocus />}
            {active === 'filter' && (
              <Grid gap={1} align="center" justify="center">
                {filtersList}
              </Grid>
            )}
            {active === 'config' && (
              <Grid gap={1} align="center">
                <Text size="small" bold>
                  {t('include')}:
                </Text>
                {useDisabledOption && (
                  <Switch
                    label={t('disabled')}
                    size="small"
                    onChange={handleChange('includeDisabled')}
                    value={includeDisabled}
                    noMargin
                  />
                )}
                {useDeletedOption && (
                  <Switch
                    label={t('deleted')}
                    size="small"
                    onChange={handleChange('includeDeleted')}
                    value={includeDeleted}
                    noMargin
                  />
                )}
              </Grid>
            )}
          </Col>

          {(hasFilters || hasOptions) && (
            <>
              <Line vertical height={1.2} color="dark5" />

              <Icon
                name="BsSearch"
                color={active === 'search' ? 'primary' : 'dark3'}
                onClick={() => setActive('search')}
              />

              {hasFilters && (
                <Icon
                  name="BsFillFunnelFill"
                  color={active === 'filter' ? 'primary' : 'dark3'}
                  onClick={() => setActive('filter')}
                />
              )}

              {hasOptions && (
                <Icon
                  name="BsSliders"
                  color={active === 'config' ? 'primary' : 'dark3'}
                  onClick={() => setActive('config')}
                />
              )}
            </>
          )}
        </Grid>
      )}
    </>
  )
}

export default ModalPickerHeader
